"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./style.less");

var _antd = require("antd");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NO_OP = function NO_OP() {};

var DEFAULT_HIGHLIGHT_WHEN = function DEFAULT_HIGHLIGHT_WHEN(selected) {
  return selected.length > 0;
};

var CustomMultiSelect = function CustomMultiSelect(_ref) {
  var disabled = _ref.disabled,
      title = _ref.title,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? [] : _ref$selected,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? NO_OP : _ref$onSelect,
      renderOption = _ref.renderOption,
      renderOptionPrefix = _ref.renderOptionPrefix,
      className = _ref.className,
      _ref$highlightWhen = _ref.highlightWhen,
      highlightWhen = _ref$highlightWhen === void 0 ? DEFAULT_HIGHLIGHT_WHEN : _ref$highlightWhen,
      _ref$wideMenu = _ref.wideMenu,
      wideMenu = _ref$wideMenu === void 0 ? false : _ref$wideMenu,
      _ref$inModal = _ref.inModal,
      inModal = _ref$inModal === void 0 ? false : _ref$inModal,
      _ref$disabledOptions = _ref.disabledOptions,
      disabledOptions = _ref$disabledOptions === void 0 ? [] : _ref$disabledOptions;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      selectOpen = _useState2[0],
      setSelectOpen = _useState2[1];

  var isHighlighted = (0, _react.useMemo)(function () {
    return highlightWhen(selected);
  }, [highlightWhen, selected]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomMultiSelect ".concat(className ? className : '')
  }, /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    mode: "multiple",
    size: "large",
    disabled: disabled,
    className: "CustomMultiSelect-button ".concat(selectOpen || isHighlighted ? 'CustomMultiSelect-open' : 'CustomMultiSelect-closed', " ").concat(disabled ? 'CustomMultiSelect-disabled' : ''),
    dropdownClassName: "CustomMultiSelect-menu".concat(inModal ? " CustomMultiSelect-menu-modal" : '').concat(wideMenu ? ' CustomMultiSelect-menu-wide' : ''),
    optionFilterProp: "title",
    value: selected || undefined,
    onChange: onSelect,
    tagRender: function tagRender() {
      return null;
    },
    open: selectOpen,
    onDropdownVisibleChange: setSelectOpen,
    showArrow: true,
    virtual: false
  }, options.map(function (_ref2) {
    var slug = _ref2.slug,
        name = _ref2.name,
        rest = _objectWithoutProperties(_ref2, ["slug", "name"]);

    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: slug,
      value: slug,
      title: name || slug,
      className: "CustomMultiSelect-option",
      disabled: disabledOptions.length && disabledOptions.includes(slug)
    }, renderOption ? renderOption({
      name: name,
      slug: slug
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !renderOptionPrefix ? null : /*#__PURE__*/_react.default.createElement("section", {
      className: "CustomMultiSelect-option-prefix"
    }, renderOptionPrefix(slug)), /*#__PURE__*/_react.default.createElement("span", {
      className: "CustomMultiSelect-option-name"
    }, name)));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "fakePlaceholder",
    onClick: function onClick() {
      return setSelectOpen(true);
    }
  }, selectOpen ? null : "".concat(title).concat(isHighlighted ? " \u2022 ".concat(selected.length) : ''))));
};

var _default = CustomMultiSelect;
exports.default = _default;